// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"transform-1"},"children":[{"tag":"g","attrs":{"id":"fill2"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M21 7H17V3H21V7Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M7 7H3L3.00001 3H7V7Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M21 21H17V17H21V21Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M7 21H3V17H7V21Z"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M5 17V7M5 17H3V21H7V19M5 17H7V19M5 7L3 7L3.00001 3H7V5M5 7L7 7V5M7 5H17M17 5L17 7L19 7M17 5L17 3H21V7L19 7M19 7V17M19 17H17L17 19M19 17H21V21H17L17 19M17 19H7","strokeWidth":"props.strokeWidth"}}]}]};

const Transform1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'transform-1',
    ref,
    icon: element,
  },
));

Transform1Icon.displayName = 'Transform1Icon';

export default Transform1Icon;
